import { useCallback } from 'react';

import { BonusProgramConfig } from '~/data/rewarding/types';
import { NON_PRESENT_CONFIG } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/Common';

import {
  GenericProposalConfigUtils,
  ProposalConfigSelectorOption,
  useGenericProposalConfigUtils,
} from '../../Common/components/ProposalConfigSelector';

export const useBonusProgramConfigUtils =
  (): GenericProposalConfigUtils<BonusProgramConfig> => {
    const convertConfigToOption = useCallback(
      (config: BonusProgramConfig): ProposalConfigSelectorOption => {
        return {
          id: config.fEmplSubUId,
          type: config.fIncentiveShortType,
          amount: config.fEmplBonusValue,
          info: config.fIncentiveShortInfo,
        };
      },
      [],
    );

    const getNonPresentConfig = useCallback(
      (configType: string, id?: string): BonusProgramConfig => {
        return {
          fEmplId: 0,
          fEmplSubUId: id || NON_PRESENT_CONFIG,
          fIncentiveShortTarget: 0,
          fIncentiveShortType: configType,
          fIncentiveShortInfo: '',
          fIncentiveShortStartDate: '',
          fEmplSubEnteredTime: '',
        };
      },
      [],
    );

    return useGenericProposalConfigUtils({
      convertConfigToOption,
      getNonPresentConfig,
    });
  };
